export default ($) => {

	let destination_top;
	if( $('#wpadminbar').length ) {

		$(window).on('resize load', function() {
			if ($(window).width() <= '768') {
				destination_top = 100;
			} else {
				destination_top = 145;
			}
		});

	} else {

		$(window).on('resize load', function() {
			if ($(window).width() <= '768') {
				destination_top = 70;
			} else {
				destination_top = 110;
			}
		});

	}

	if($('body').hasClass('page-water-care')) {

		window.hashName = window.location.hash;
		$(window).load(function () {
			if($(window.hashName).length) {
				$('html, body').animate({scrollTop: $(window.hashName).offset().top-destination_top}, 0);

				return false;
			}
		});
	}

	$(".page-water-care a").on("click", function () {
		const destination = $($(this).attr('href')).offset().top - destination_top;
		$( 'html, body' ).animate( { scrollTop: destination } );
	});

}
